import React, { useContext } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import QuestionHeading from '@f/applications/QuizApp/partials/QuestionHeading'
import { QuizStep } from '@f/applications/QuizApp/partials/types'
import { QuestionRadioButton } from '@f/applications/QuizApp/questions/QuestionRadio/QuestionRadioButton'
import { BarTile } from '@f/elements/BarTile/BarTile'

import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

interface Props {
  step: QuizStep
}

export const QuestionFinanceBuyingStage = ({ step }: Props) => {
  const context = useContext(QuizContext) as $TSFixMe
  const loanPurpose = context.data.steps.find(
    (s: QuizStep) => s.id === 'loan_purpose'
  )?.values?.[0]?.value
  const loanPurposeIsBuilding = loanPurpose === 'building_project'

  const options = [
    {
      value: 'searching',
      label: loanPurposeIsBuilding
        ? 'Noch in Planung'
        : 'Immobilie nicht besichtigt'
    },
    {
      value: 'evaluating',
      label: loanPurposeIsBuilding
        ? 'Grundstück besichtigt'
        : 'Immobilie besichtigt'
    },
    {
      value: 'found',
      label: 'In Kaufverhandlungen'
    }
  ]

  const questionOptions = options.map(option => ({
    ...option,
    ItemTemplate: (radio: { label: string }) => <BarTile label={radio.label} />
  }))

  const handleChange = (value: string) => {
    const defaultIndicates = ['funnel-step-change']

    const indicates = step.indicates || defaultIndicates

    window._wt({
      category: 'form',
      action: 'submit',
      location: `question-${step._wtName}`,
      indicates,
      values: [
        {
          type: step._wtName,
          value: value
        }
      ],
      ...context.tracking.flow
    })

    context.actions.updateValues({
      stepID: step.id,
      valuesToSave: [
        {
          name: step.values[0].name,
          value: value
        }
      ]
    })

    context.actions.move({ to: 'next', triggerSubmit: false })
  }

  return (
    <>
      <QuestionHeading heading={step.heading} subheading={step.subheading} />
      <div className={`[ f-m-h-auto ] QuestionRadio-wrap`}>
        <div className='[ f-d-flc ] QuestionRadio-options'>
          <div className='QuestionRadio-bar-tiles'>
            {questionOptions.map(({ ItemTemplate, ...option }) => (
              <QuestionRadioButton
                key={option.value}
                wtData={{
                  location: `question-${step._wtName}`,
                  ...context.tracking.flow
                }}
                onClick={() => handleChange(option.value as string)}>
                <ItemTemplate {...option} />
              </QuestionRadioButton>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
